export default "__VITE_ASSET__DaH6yK11__"